import React from 'react';
import YouTube from '../components/concert-entry/youtube.component';
import VideoBehindText from '../components/video-image-background/video-behind-text.component';
import videoData from '../data/video-data';


const VideoPage: React.FC = () => (
   <VideoBehindText mainText="Videos" url="bg.jpg">
      <div className="flex flex-wrap justify-center">
         {
            videoData.map(
               (video, index) =>
                  <caption className="pt-2 pb-8">
                     <YouTube key={index} id={video.url} />
                     {video.caption}
                  </caption>)
         }
      </div>
   </VideoBehindText>
);

export default VideoPage;